import { render, staticRenderFns } from "./return-pr-modal.vue?vue&type=template&id=8de27b98&"
import script from "./return-pr-modal.vue?vue&type=script&lang=js&"
export * from "./return-pr-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports